import type { Infer } from 'superstruct';
import { assign, object, optional, string } from 'superstruct';

import { PaginationQuery, SortQueryDefaulted } from '@adflow/shared/util-data';
import { parsableBoolean } from '@adflow/shared/util-superstruct';

import { MediaKindDto } from './media-types.dto';
import type { ViewMediaDto } from './view-media.dto';

const MediaSortableFields: (keyof ViewMediaDto)[] = [
	'name',
	'kind',
	'width',
	'height',
	'duration',
	'createdAt',
	'archived',
	'googleAdsAccount',
] as const;

export const DEFAULT_MEDIA_SORT = 'name';
export const DEFAULT_MEDIA_SORT_DIR = 'asc';
const ListMediaSort = SortQueryDefaulted(
	MediaSortableFields,
	DEFAULT_MEDIA_SORT,
	DEFAULT_MEDIA_SORT_DIR
);

export const MediaFilterDto = object({
	kind: optional(MediaKindDto),
	archived: optional(parsableBoolean()),
});

export const ListMediaQueryDto = assign(
	PaginationQuery,
	ListMediaSort,
	object({
		search: string(),
		filter: optional(MediaFilterDto),
	})
);

export type ListMediaQueryDto = Infer<typeof ListMediaQueryDto>;
